import React from 'react';
import styled from 'styled-components';
import renaultLogo from '../images/RENAULT_LOGO_english.png';
import help from '../images/question.png';
import {Flex, Image, Margin, Padding} from './common/StyledComponents';
import {NavLink} from 'react-router-dom';
import {HELP_PATH} from '../routes/paths';
import {FormattedMessage} from 'react-intl';
import commonMessages from '../intl/common/commonMessages';
import {connect} from 'react-redux';
import {moduleRoles} from '../utils/roles';
import {domains} from '../constants/Utils';

const Title = styled.h1`
    margin: 0;
    margin-top: 5px;
`;
Title.displayName = 'Title';

const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    background-color: white;
    padding: 8px;

    @media (max-height: 450px) {
        display: none;
    };
`;

const isNotOnlyDealer = (roles) => {
    const ase = domains.ASE;
    return moduleRoles.isAdmin(roles, ase)
        || moduleRoles.isPowerUser(roles, ase)
        || moduleRoles.isEditor(roles, ase)
        || moduleRoles.isSGEditor(roles, ase)
        || moduleRoles.isSGAdmin(roles, ase)
}

const Header = ({roles}) => (
    <HeaderWrapper className="">
        <Flex>
            <Margin left={15}>
                <Image height={60} src={renaultLogo}/>
            </Margin>
            <Margin left={15}>
                <Title>TRACE</Title>
            </Margin>
        </Flex>
        {/*{isNotOnlyDealer(roles) && <Help/>}*/}
    </HeaderWrapper>
);

const Help = () => {
    return <Margin top={13} right={20}>
        <Flex>
            <NavLink to={HELP_PATH}>
                <Image width={25} height={25} src={help}/>
            </NavLink>
            <Margin left={5}><FormattedMessage {...commonMessages.HELP}/></Margin>
        </Flex>
    </Margin>
}

const mapStateToProps = state => ({
    roles: state.profile.userDetail.roles,
});

export default connect(mapStateToProps)(Header);
